export default __webpack_public_path__ + "static/media/09AW3JAN66.b0da0f97.jpg";